import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('contact_alt') as string || '').trim();
    if (honeypotVal) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }
    setStatus('loading');
    try {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <section className="py-12 md:py-16 bg-primary-500">
      <div className="w-full max-w-2xl mx-auto px-4 text-center">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
          订阅韩漫更新资讯
        </h2>
        <p className="text-primary-100 text-sm md:text-base mb-6">
          第一时间获取最新漫画更新通知，不错过任何精彩内容
        </p>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
        >
          <div className="form-shield">
            <input type="text" name="contact_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 w-full sm:w-auto px-5 py-3 rounded-full bg-background-50 text-foreground-900 placeholder-foreground-400 text-sm outline-none border-2 border-transparent focus:border-primary-300 transition-all"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>
        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-background-50' : 'text-accent-200'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}
